import { CSSProperties, MouseEvent } from 'react'
import _ from 'lodash'
import classnames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { Button as AntButton } from 'antd'
import { ButtonProps, ButtonType } from 'antd/lib/button/button'

import generateGuideSlug from '~/lib/generateGuideSlug'
import { useWithTrackLinkClick } from '../useWithTrackLinkClick'

const OMITS = ['dispatch', 'to']

export type FictivButtonType = ButtonType | 'danger'

export type ButtonPropsType = Omit<ButtonProps, 'onClick' | 'type'> & {
    name?: string
    placement?: string
    // Todo make the type of event consistent
    onClick?: ((event: any) => any) | Function
    to?: string | null
    ['data-test-target']?: string
    from?: string
    danger?: boolean
    style?: CSSProperties
    // For some reason the default antd ButtonType doesn't include 'error'...
    // so there's a type casting later on when the props are spread
    type?: FictivButtonType
    // questionable property
    width?: string
    // questionable property
    height?: string
    // questionable property
    tooltip?: string
}

function Button(props: ButtonPropsType) {
    // These are all the attributes that are not passed through to the real html elements
    const {
        disabled,
        onClick,
        to = '',
        children,
        className,
        placement,
        name,
        target,
        danger = false,
    } = props

    // Cast to ButtonProps because of the `types` property
    const newProps = _.omit(props, OMITS) as ButtonProps

    const guidename = generateGuideSlug(placement, name)
    const navigate = useNavigate()

    const handleOnClick = (evt: MouseEvent) => {
        if (disabled) {
            return
        }

        if (onClick) {
            onClick(evt)
        }

        if (to) {
            navigate(to)
        }
    }

    const onClickWithTrackLink = useWithTrackLinkClick(props, handleOnClick)

    //this is for browser security :+1:
    const rel = target === '_blank' ? 'noopener noreferrer' : ''

    return (
        <AntButton
            {...newProps}
            data-placement={placement}
            data-name={name}
            className={classnames(guidename, className)}
            onClick={onClickWithTrackLink}
            rel={rel}
            danger={danger}
        >
            {children}
        </AntButton>
    )
}

// antd tooltip has fix for tooltip for disabled buttons but it works only when wrapped with tooltip component has specific types(including `button`)
// https://github.com/ant-design/ant-design/blob/4.17.4/components/tooltip/index.tsx#L88
Button.__ANT_BUTTON = true
Button.Group = AntButton.Group
export default Button
